import React, { useMemo, useEffect } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import {
	OfferStoreContext,
	OfferOptionsContext,
	LookupContext,
} from "@gp/components";

import { AdditionalOffer } from "@features/offer/desktop/additional-offer";
import { ErrorPage } from "@components-shared/desktop/error";

import LiveViewStore from "@state/stores/offer/live/LiveViewStore";
import { useRootAppStore } from "@hooks";
import { setTabTitle } from "@utils";
import { history } from "@state";
import {
	additionalOfferToggle,
	useNumberOfAvailableColumns,
} from "@utils/offer";
import { EventOffer } from "@gp/offer";

import { LiveOfferMenuStore } from "@state/stores/offer/live/LiveOfferMenuStore";

import { LivePageTemplateCore } from "./components";

export default observer(function LivePage(props: {
	liveOfferMenuStore: LiveOfferMenuStore;
}) {
	const t = useTranslation().t;
	const rootStore = useRootAppStore();
	const liveViewStore = useMemo(
		() => new LiveViewStore(rootStore, props.liveOfferMenuStore),
		[]
	);
	const numberOfColumns = useNumberOfAvailableColumns(
		rootStore.resizeStore.availableColumns
	);
	liveViewStore.setNumberOfColumns(numberOfColumns);

	useEffect(() => {
		setTabTitle(t("HOME.LIVE_BETTING"));
		document.querySelector("html, body")?.scrollTo(0, 0);
		//call this method to trigger check for popups and update popup timeouts
		rootStore.initClick();

		liveViewStore.onInitialize();
		return liveViewStore.onDispose;
	}, []);

	const toggleAdditionalOfferKeepingState = (
		event: EventOffer,
		betBuilderDisplayGroup: string
	) =>
		additionalOfferToggle(
			event,
			betBuilderDisplayGroup,
			history.location.state
		);

	const options = {
		numberOfColumns,
		scoreChangeDuration: 3500,
		enableInlineAdditionalOffer: false,
		isLive: liveViewStore.isLive,
		additionalOfferToggle: toggleAdditionalOfferKeepingState,
		bettingTypeSelectorsStore:
			liveViewStore.configuration.bettingTypeSelectorsStore,
		shouldHideTopTag:
			props.liveOfferMenuStore.selectedPeriod.period == "highlights",
	};

	return (
		// TODO: review this, might not be good to kill entire store!
		// eslint-disable-next-line react/jsx-handler-names
		<ErrorPage onError={liveViewStore.onDispose}>
			<OfferStoreContext.Provider value={liveViewStore}>
				<LookupContext.Provider value={liveViewStore.lookupsStore}>
					<OfferOptionsContext.Provider value={options}>
						<LivePageTemplateCore store={liveViewStore} />
					</OfferOptionsContext.Provider>
				</LookupContext.Provider>
			</OfferStoreContext.Provider>
			<AdditionalOffer />

			<Tooltip
				id="bt-description"
				className="at-tooltipBettingType react-tooltip--primary"
				place="bottom"
				closeOnResize={true}
			/>
		</ErrorPage>
	);
});
